// Local
import {initUiKit} from "./ui-kit";
import RoutePinger from "./partials/route-pinger";
import AjaxData from './partials/ajax-data';

window.initDom = ($wrapper) => {
    // Helper to make sure the ui-kit gets initialized in the cms preview
    if (! $wrapper.uiKitInitialized) {
        initUiKit($wrapper);
    }

    $wrapper.querySelectorAll('[data-toggle-like]').forEach(async ($el) => {
        const {LikeToggle} = await import('./partials/like-toggle');
        (new LikeToggle($el));
    });

    $wrapper.querySelectorAll('[data-block-type="team-event-calendar"],[data-block-type="show-report-list"],[data-block-type="team-article-list"]').forEach(async($el) => {
        const ListWithFilters = await import('./block/list-with-filters');
        (new ListWithFilters.default($el));
    });

    $wrapper.querySelectorAll('[data-block-type="information-sheet-form"] form').forEach(async($el) => {
        const InformationSheetForm = await import('./block/information-sheet-form');
        (new InformationSheetForm.default($el));
    });

    $wrapper.querySelectorAll('[data-block-type="show-report-form"] form').forEach(async($el) => {
        const ShowReportForm = await import('./block/show-report-form');
        (new ShowReportForm.default($el));
    });

    $wrapper.querySelectorAll('.collapsable-trigger').forEach(async ($el) => {
        const InlineCollapsable = await import('./partials/inline-collapsable');
        (new InlineCollapsable.default($el));
    });

    $wrapper.querySelectorAll('[data-search]').forEach(async ($el) => {
        const Search = await import('./partials/search');
        (new Search.default($el));
    });

    __cmp("addEventListener", ["consentscreenoff", () => {
        const url = new URL(window.location);
        url.searchParams.delete('cmpscreencustom');
        window.history.replaceState({}, document.title, url.pathname + url.search);
    },false],null);

    (new AjaxData($wrapper)).updateDom();
}

(function() {
    window.initDom(document);

    const pinger = new RoutePinger(`${placeholders.router.baseUri}/ping`);
    pinger.start();
})();